/* Models */
import { Schedule } from '../models';

/* ActionTypes */
import { SCHEDULE_ENTITY_ACTION_TYPES } from './actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const schedulesReducer = generateEntityReducer(SCHEDULE_ENTITY_ACTION_TYPES, Schedule);

export default schedulesReducer;
